<template>
  <div class="main">
    <el-row>
      <el-col ref="leftTree" id="leftTree" class="leftTree" :span="5">
        <el-tree :data="template" :props="treeProps" :expand-on-click-node="false"
                 :default-expand-all="true" @node-click="clickTreeNode" @node-contextmenu="treeNodeMenu">
        </el-tree>
      </el-col>
      <el-col class="rightTable" :span="19" style="min-width: 766px">
        <!--图形设置-->
        <div v-if="itemType === 'MapSetting'">
          <el-divider content-position="left">显示设置</el-divider>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>横向比例</span>
            </el-col>
            <el-col :span="6" align="left">
              <el-select size="mini" v-model="itemData.mapScale" style="width: 120px">
                <el-option v-for="item in scaleOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="6" align="left">
              <span style="margin-right: 5px">宽度</span>
              <el-input size="mini" v-model.number="itemData.mapWidth" style="width: 80px"></el-input>
            </el-col>
            <el-col :span="6" align="left">
              <span style="margin-right: 5px">高度</span>
              <el-input size="mini" v-model.number="itemData.mapHeight" style="width: 80px"></el-input>
            </el-col>
          </el-row>
          <el-divider content-position="left">砂体连通设置</el-divider>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>尖灭长度</span>
            </el-col>
            <el-col :span="7" align="left">
              <el-select size="mini" v-model="itemData.pinchLength" style="width: 120px">
                <el-option v-for="item in pinchLengthOption" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <!--井柱设置-->
        <div v-if="itemType === 'WellSetting'">
          <el-divider content-position="left">显示设置</el-divider>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>深度比例:</span>
            </el-col>
            <el-col :span="4" align="left">
              <el-select size="mini" v-model="itemData.depthScale" style="width: 100%">
                <el-option v-for="item in scaleOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" :offset="3">
              <span>边框样式</span>
            </el-col>
            <el-col :span="8" align="left">
<!--              <el-switch v-model="itemData.showBorder"></el-switch>-->
              <el-radio v-model="itemData.borderStyle" :label=0>隐藏</el-radio>
              <el-radio v-model="itemData.borderStyle" :label=1>显示</el-radio>
              <el-radio v-model="itemData.borderStyle" :label=2>简洁</el-radio>
            </el-col>
          </el-row>
          <el-row v-if="createDataType == 0">
            <el-col :span="3" :offset="2" align="left" >
              <span>分层级别:</span>
            </el-col>
            <el-col :span="4">
              <el-select size="mini" v-model="itemData.stratumLevel" style="width: 100%" @change="stratumLevelChanged">
                <el-option v-for="item in stratumLevelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>显示范围</span>
            </el-col>
            <el-col :span="7" align="left">
              <el-radio v-model="itemData.depthType" :label=0>深度</el-radio>
            </el-col>
            <el-col v-if="itemData.depthType === 0" :span="12" align="left">
              <span style="margin-right: 35px">顶部深度</span>
              <el-input size="mini" v-model.number="itemData.topDepth" style="width:120px"></el-input>
            </el-col>
            <el-col v-if="itemData.depthType === 1" :span="12" align="left">
              <span style="margin-right: 35px">顶部层位</span>
              <el-select size="mini" v-model="itemData.topLayer" style="width: 120px">
                <el-option v-for="item in layerOption" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
            </el-col>
            <el-col :span="7" align="left">
              <el-radio v-model="itemData.depthType" :label=1>分层</el-radio>
            </el-col>
            <el-col v-if="itemData.depthType === 0" :span="12" align="left">
              <span style="margin-right: 35px">底部深度</span>
              <el-input size="mini" v-model.number="itemData.botDepth" style="width:120px"></el-input>
            </el-col>
            <el-col v-if="itemData.depthType === 1" :span="12" align="left">
              <span style="margin-right: 35px">底部层位</span>
              <el-select size="mini"  v-model="itemData.botLayer" style="width: 120px">
                <el-option v-for="item in layerOption" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <!--深度道设置-->
        <div v-if="itemType === 'DepthTrack'">
          <el-divider content-position="left">显示设置</el-divider>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>道宽度</span>
            </el-col>
            <el-col :span="4" align="left">
              <el-input size="mini" v-model.number="itemData.trackWidth" style="margin-left: 69px; width: 120px"></el-input>
            </el-col>
          </el-row>
          <el-divider content-position="left">标注设置</el-divider>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span style="margin-right: 5px">显示</span>
              <el-switch v-model="itemData.showTickLabel"></el-switch>
            </el-col>
            <el-col :span="2" align="left">
              <span>标注间隔</span>
            </el-col>
            <el-col :span="5" align="left">
              <el-select size="mini" v-model="itemData.tickLabelStep" style="width: 120px">
                <el-option v-for="item in depthStepOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="7" align="left">
              <span style="margin-right: 5px">字体大小</span>
              <el-select size="mini" v-model="itemData.tickLabelSize" style="width: 120px">
                <el-option v-for="item in fontOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" align="left">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.tickLabelColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-divider content-position="left">主刻度设置</el-divider>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span style="margin-right: 5px">显示</span>
              <el-switch v-model="itemData.showMajorTick"></el-switch>
            </el-col>
            <el-col :span="2" align="left">
              <span>刻度间隔</span>
            </el-col>
            <el-col :span="5" align="left">
              <el-select size="mini" v-model="itemData.majorDepthStep" style="width: 120px">
                <el-option v-for="item in depthStepOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="7" align="left">
              <span  style="margin-right: 5px">线条长度</span>
              <el-select size="mini" v-model="itemData.majorTickLength" style="width: 120px">
                <el-option v-for="item in lineWidthOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" align="left">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.majorTickColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-divider content-position="left">次刻度设置</el-divider>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span style="margin-right: 5px">显示</span>
              <el-switch v-model="itemData.showMinorTick"></el-switch>
            </el-col>
            <el-col :span="2" align="left">
              <span>刻度间隔</span>
            </el-col>
            <el-col :span="5" align="left">
              <el-select size="mini" v-model="itemData.minorDepthStep" style="width: 120px">
                <el-option v-for="item in depthStepOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="7" align="left">
              <span  style="margin-right: 5px">线条长度</span>
              <el-select size="mini" v-model="itemData.minorTickLength" style="width: 120px">
                <el-option v-for="item in lineWidthOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" align="left">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model=itemData.minorTickColor></el-color-picker>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--曲线道参数设置-->
        <div v-if="itemType === 'LogCurveTrack'">
          <el-divider content-position="left">显示设置</el-divider>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>道宽度</span>
            </el-col>
            <el-col :span="4" align="left">
              <el-input size="mini" v-model.number="itemData.trackWidth" style="margin-left: 37px; width: 120px"></el-input>
            </el-col>
          </el-row>
          <el-divider content-position="left">深度网格</el-divider>
          <el-row align="middle">
            <el-col :span="4" :offset="2" align="left">
              <span>主刻度</span>
            </el-col>
            <el-col :span="4" align="left">
              <span style="margin-right: 5px">显示</span>
              <el-switch v-model="itemData.showMajorDepthGrid"></el-switch>
            </el-col>
            <el-col :span="6" align="left">
              <span style="margin-right: 5px">间隔</span>
              <el-select size="mini" v-model="itemData.majorDepthStep" style="width: 120px">
                <el-option v-for="item in depthStepOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" align="left">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.majorDepthTickColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="4" :offset="2" align="left">
              <span>次刻度</span>
            </el-col>
            <el-col :span="4" align="left">
              <span style="margin-right: 5px">显示</span>
              <el-switch v-model="itemData.showMinorDepthGrid"></el-switch>
            </el-col>
            <el-col :span="6" align="left">
              <span style="margin-right: 5px">间隔</span>
              <el-select size="mini" v-model="itemData.minorDepthStep" style="width: 120px">
                <el-option v-for="item in depthStepOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" align="left">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.minorDepthTickColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-divider content-position="left">值网格</el-divider>
          <el-row align="middle">
            <el-col :span="4" :offset="2" align="left">
              <span>主刻度</span>
            </el-col>
            <el-col :span="4" align="left">
              <span style="margin-right: 5px">显示</span>
              <el-switch v-model="itemData.showMajorValueGrid"></el-switch>
            </el-col>
            <el-col :span="6" align="left">
              <span style="margin-right: 5px">数量</span>
              <el-select size="mini" v-model="itemData.majorTickCount" style="width: 120px">
                <el-option v-for="item in depthStepOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" align="left">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.majorValueTickColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="4" :offset="2" align="left">
              <span>次刻度</span>
            </el-col>
            <el-col :span="4" align="left">
              <span style="margin-right: 5px">显示</span>
              <el-switch v-model="itemData.showMinorValueGrid"></el-switch>
            </el-col>
            <el-col :span="6" align="left">
              <span style="margin-right: 5px">数量</span>
              <el-select size="mini" v-model="itemData.minorTickCount" style="width: 120px">
                <el-option v-for="item in depthStepOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" align="left">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.minorValueTickColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="4" :offset="2" align="left">
              <span>刻度类型</span>
            </el-col>
            <el-col :span="4" align="left">
              <el-radio v-model="itemData.trackScale" label="Linear">线性刻度</el-radio>
            </el-col>
            <el-col :span="6" align="left">
              <el-radio v-model="itemData.trackScale" label="Logarithmic">对数刻度</el-radio>
            </el-col>
          </el-row>
        </div>
        <!--曲线参数设置-->
        <div v-if="itemType === 'LogCurve'">
          <el-divider content-position="left">显示设置</el-divider>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>显示曲线</span>
            </el-col>
            <el-col :span="7">
              <el-switch v-model="itemData.showCurve"></el-switch>
            </el-col>
            <el-col :span="12" align="left">
              <span style="margin-right: 5px">曲线类型</span>
              <el-select size="mini" v-model="itemData.curveName" allow-create filterable=true default-first-option style="width: 100px">
                <el-option v-for="item in curveNameOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>自动刻度范围</span>
            </el-col>
            <el-col :span="7">
              <el-switch v-model="itemData.autoValue"></el-switch>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>刻度范围设置</span>
            </el-col>
            <el-col :span="7">
              <el-input size="mini" v-model.number="itemData.leftValue" style="width:60px"></el-input>
              <i class="el-icon-right"></i>
              <el-input size="mini" v-model.number="itemData.rightValue" style="width:60px"></el-input>
            </el-col>
            <el-col :span="12" align="left">
              <span style="margin-right: 5px">反向绘制</span>
              <el-switch v-model="itemData.reverse"></el-switch>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>线条类型</span>
            </el-col>
            <el-col :span="7">
              <el-select size="mini" v-model="itemData.lineStyle" style="width: 135px">
                <el-option label="-------" value="2,2"><i class="el-icon-edit"></i></el-option>
                <el-option label="·············" value="1,1"></el-option>
                <el-option label="‐·‐·‐·‐·‐" value="2,1"></el-option>
                <el-option label="‐··‐··‐··‐" value="2,1,1"></el-option>
              </el-select>
            </el-col>
            <el-col :span="12" align="left">
              <div class="fence-color-block">
                <span class="color-label">线条颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.lineColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span style="margin-right: 35px">线条宽度</span>
            </el-col>
            <el-col :span="7">
              <el-select size="mini" v-model="itemData.lineWidth" style="width: 135px">
                <el-option v-for="item in lineWidthOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-divider content-position="left">填充设置</el-divider>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>参考边界</span>
            </el-col>
            <el-col :span="7">
              <el-select size="mini" v-model="itemData.fillTargetType" style="width: 120px">
                <el-option v-for="item in fillBorderOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="2" align="left">
              <span>标示线值</span>
            </el-col>
            <el-col :span="6" align="left">
              <el-input-number size="mini" v-model="itemData.fillTargetValue" style="margin-left: 5px; width: 100px"></el-input-number>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>填充左侧</span>
            </el-col>
            <el-col :span="5">
              <el-switch v-model="itemData.fillLeft"></el-switch>
            </el-col>
            <el-col :span="3" :offset="2" align="left">
              <div class="fence-color-block">
                <span class="color-label">填充颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.leftFillColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="3" :offset="2" align="left">
              <span>填充右侧</span>
            </el-col>
            <el-col :span="5">
              <el-switch v-model="itemData.fillRight"></el-switch>
            </el-col>
            <el-col :span="3" :offset="2" align="left">
              <div class="fence-color-block">
                <span class="color-label">填充颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.rightFillColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--解释道设置-->
        <div v-if="itemType === 'ExplainTrack'">
          <el-divider content-position="left">显示设置</el-divider>
          <el-row align="middle">
            <el-col :span="5" :offset="2" align="left">
              <span>道宽度</span>
            </el-col>
            <el-col :span="4" :offset="2" align="left">
              <el-input size="mini" v-model.number="itemData.trackWidth" style="width: 120px"></el-input>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="5" :offset="2" align="left">
              <span style="margin-right: 5px">显示解释结论</span>
              <el-switch v-model="itemData.showLabel"></el-switch>
            </el-col>
            <el-col :span="2" align="left">
              <span >字体大小</span>
            </el-col>
            <el-col :span="4" align="left">
              <el-select size="mini" v-model="itemData.labelSize" style="width: 120px">
                <el-option v-for="item in fontOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.labelColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-row align="middle" style="margin-top: 20px">
            <el-col :span="6" :offset="2" align="left">
              <span style="margin-right: 5px">显示填充</span>
              <el-switch v-model="itemData.showFill"></el-switch>
            </el-col>
          </el-row>

        </div>
        <!--地层道设置-->
        <div v-if="itemType === 'StratumTrack'">
          <el-divider content-position="left">显示设置</el-divider>
          <el-row align="middle">
            <el-col :span="5" :offset="2" align="left">
              <span>道宽度</span>
            </el-col>
            <el-col :span="4" :offset="2" align="left">
              <el-input size="mini" v-model.number="itemData.trackWidth" style="width: 120px"></el-input>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="5" :offset="2" align="left">
              <span style="margin-right: 5px">显示层名</span>
              <el-switch v-model="itemData.showLabel"></el-switch>
            </el-col>
            <el-col :span="2" align="left">
              <span >字体大小</span>
            </el-col>
            <el-col :span="4" align="left">
              <el-select size="mini" v-model="itemData.labelSize" style="width: 120px">
                <el-option v-for="item in fontOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.labelColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="false" align="middle" style="margin-top: 20px">
            <el-col :span="6" :offset="2" align="left">
              <span style="margin-right: 5px">显示填充</span>
              <el-switch v-model="itemData.showFill"></el-switch>
            </el-col>
          </el-row>
        </div>
        <!--砂岩道设置-->
        <div v-if="itemType === 'SandTrack'">
          <el-divider content-position="left">显示设置</el-divider>
          <el-row align="middle">
            <el-col :span="5" :offset="2" align="left">
              <span>道宽度</span>
            </el-col>
            <el-col :span="4" :offset="2" align="left">
              <el-input size="mini" v-model.number="itemData.trackWidth" style="width: 120px"></el-input>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="5" :offset="2" align="left">
              <span style="margin-right: 5px">显示厚度</span>
              <el-switch v-model="itemData.showLabel"></el-switch>
            </el-col>
            <el-col :span="2" align="left">
              <span >字体大小</span>
            </el-col>
            <el-col :span="4" align="left">
              <el-select size="mini" v-model="itemData.labelSize" style="width: 120px">
                <el-option v-for="item in fontOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.labelColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-row align="middle" style="margin-top: 20px">
            <el-col :span="5" :offset="2" align="left" v-if="false">
              <span style="margin-right: 5px">显示填充</span>
              <el-switch v-model="itemData.showFill"></el-switch>
            </el-col>

            <el-col :span="6" align="left" :offset="2">
              <div class="fence-color-block">
                <span class="color-label">填充颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.fillColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--射孔道设置-->
        <div v-if="itemType === 'PerfTrack'">
          <el-divider content-position="left">显示设置</el-divider>
          <el-row align="middle">
            <el-col :span="5" :offset="2" align="left">
              <span>道宽度</span>
            </el-col>
            <el-col :span="4" :offset="2" align="left">
              <el-input size="mini" v-model.number="itemData.trackWidth" style="width: 120px"></el-input>
            </el-col>
          </el-row>
          <el-row align="middle">
            <el-col :span="5" :offset="2" align="left">
              <span style="margin-right: 5px">显示射孔厚度</span>
              <el-switch v-model="itemData.showLabel"></el-switch>
            </el-col>
            <el-col :span="2" align="left">
              <span >字体大小</span>
            </el-col>
            <el-col :span="4" align="left">
              <el-select size="mini" v-model="itemData.labelSize" style="width: 120px">
                <el-option v-for="item in fontOptions" :key=item.value :label=item.label :value=item.value></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <div class="fence-color-block">
                <span class="color-label">颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.labelColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-row align="middle" style="margin-top: 20px">
            <el-col :span="6" :offset="2" align="left">
              <div class="fence-color-block">
                <span class="color-label">射孔符号颜色</span>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="itemData.symbolColor"></el-color-picker>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!--右键菜单-->
    <div v-show="showContextMenu" left="0" top="0" id="right-key-menu" class="right-key-menu">
      <div v-if="itemMoveable">
        <div class="rightKeyMenuItem" @click="itemMoveUp">上移</div>
        <div class="rightKeyMenuItem" @click="itemMoveDown">下移</div>
        <div v-if="itemType === 'LogCurveTrack'" class="rightKeyMenuItem" @click="addCurve">添加</div>
        <div class="rightKeyMenuItem" @click="itemDelete">删除</div>
      </div>
      <div v-if="itemType === 'WellSetting'">
        <div id="DepthTrack" class="rightKeyMenuItem" @click="addTrack">深度道</div>
        <div id="LogCurveTrack" class="rightKeyMenuItem" @click="addTrack">曲线道</div>
        <div id="ExplainTrack" class="rightKeyMenuItem" @click="addTrack">解释结论道</div>
        <div id="StratumTrack" class="rightKeyMenuItem" @click="addTrack">地层道</div>
        <div id="SandTrack" class="rightKeyMenuItem" @click="addTrack">砂岩道</div>
        <div id="PerfTrack" class="rightKeyMenuItem" @click="addTrack">射孔道</div>
      </div>
    </div>
  </div>
</template>
<script>

import defaultCurve from '../../public/static/data/defaultCurve.json';
import defaultTrack from '../../public/static/data/defaultTrack.json';
import axios from "axios";

import { ElMessage, ElMessageBox } from 'element-plus';

function newCurve(name) {
  const curve = JSON.parse(JSON.stringify(defaultCurve));
  curve.label = name;
  return curve;
}

function newTrack(trackType, trackName) {
  let track = null;

  if (trackType in defaultTrack) {
    track = JSON.parse(JSON.stringify(defaultTrack[trackType]));
    track.label = trackName;
  }
  return track;
}

export default {
  name: "FenceConfig",
  props : ["fence", "fenceWells"],
  data: function () {
    return {
      treeProps: {
        children: 'children',
        label: 'label'
      },
      createDataType:0,//0系统 1 本地
      template: JSON.parse(JSON.stringify(this.fence)),
      wells :  JSON.parse(JSON.stringify(this.fenceWells)),
      itemType: "",
      itemData: "",
      itemNode: null,
      itemMoveable : false,
      showContextMenu: false,
      fontOptions : [{label:"5", value:5},
        {label:"5.5", value:5.5},
        {label:"6.5", value:6.5},
        {label:"7.5", value:7.5},
        {label:"8", value:8},
        {label:"9", value:9},
        {label:"10", value:10},
        {label:"10.5", value:10.5},
        {label:"11", value:11},
        {label:"12", value:12},
        {label:"14", value:14},
        {label:"16", value:16},
        {label:"18", value:18},
        {label:"20", value:20},
        {label:"22", value:22},
        {label:"24", value:24},
        {label:"26", value:26},
        {label:"28", value:28},
        {label:"36", value:36},
        {label:"48", value:48},
        {label:"72", value:72}],
      scaleOptions : [{label:"1:50",value:50},
        {label:"1:100",value:100},
        {label:"1:200",value:200},
        {label:"1:300",value:300},
        {label:"1:500",value:500},
        {label:"1:1000",value:1000},
        {label:"1:2000",value:2000},
        {label:"1:3000",value:3000}],
      depthStepOptions : [{label:"1", value:1},
        {label:"2", value:2},
        {label:"5", value:5},
        {label:"10", value:10},
        {label:"20", value:20},
        {label:"50", value:50}],
      lineWidthOptions:[{label:"1", value:1},
        {label:"2", value:2},
        {label:"3", value:3},
        {label:"4", value:4},
        {label:"5", value:5}],
      fillBorderOptions:[{label:"边界", value:1},
        {label:"标示线", value:2},
        {label:"另一条曲线", value:3}],
      pinchLengthOption:[{label:"1/2", value:1},
        {label:"1/4", value:2},
        {label:"1/3", value:3},
        {label:"Lh/H", value:4},
        {label:"Lh/(h+1)", value:5}],
      templateOption:[{label:"[系统]默认模板1", value:"[系统]默认模板1"},
        {label:"[系统]默认模板2", value:"[系统]默认模板2"},
        {label:"[个人]默认模板1", value:"[个人]默认模板1"},
        {label:"[个人]默认模板2", value:"[个人]默认模板2"}],
      layerOption:[{label:"S11", value:"S11"},
        {label:"S12", value:"S12"},
        {label:"S21", value:"S21"},
        {label:"S22", value:"S22"},
        {label:"S31", value:"S31"},
        {label:"S32", value:"S32"}],
      stratumLevelOptions:[
        {label:"系分层", value: "0"},
        {label:"组分层", value: "1"},
        {label:"段分层", value: "2"},
        {label:"小层分层", value: "3"}
      ],
      curveNameOptions:[
        {label:"GR", value: "GR"},
        {label:"SP", value: "SP"}
      ],
      predefineColors : ["#ffffff","#000000","#e7e6e6","#44546a","#5b9bd5","#ed7d31","#a5a5a5","#ffc000",
        "#4472c4","#70ad47","#7f7f7f","#0c0c0c","#171616","#222a35","#1e4e79","#833c0b","#525252",
        "#7f6000","#1f3864","#375623","#c00000","#ff0000","#ffc000","#ffff00","#92d050","#00b050",
        "#00b0f0","#0070c0","#002060","#7030a0"]
    }
  },
  methods: {
    reloadTemplate() {
      this.template = JSON.parse(JSON.stringify(this.fence));

      let level = '0';
      for(const config of this.template) {
        if (config.type === 'WellSetting') {
          level = config.stratumLevel;
        }
      }
      if(this.createDataType == 0) this.loadStratums(level);
    },
    stratumLevelChanged(val) {
      if(this.createDataType == 0) this.loadStratums(val);
    },
    loadStratumLevels() {
      const url = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/map/leve";
      axios.get(url, {params:{"authorization":"12345"}}).then(res => {
        this.stratumLevelOptions = [];

        for(const i in res.data.data) {
          const item = {label:res.data.data[i], value:i};
          this.stratumLevelOptions.push(item);
          console.log(this.stratumLevelOptions);
        }
      }).catch(err => {
        console.log(err);
      });
    },
    loadStratums(val) {
      const params = {
        "well" : this.fenceWells,
        "level" : val,
        "autorization" : localStorage.getItem("lyqtJwt")
      };

      console.log(params);
      const url = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/map/layered";
      axios.post(url, params).then(res => {
        this.layerOption = [];
        for(const layer of res.data.data) {
          this.layerOption.push({label:layer,value:layer});
        }
      }).catch(err => {
        console.log(err);
      });
    },
    loadCurveNames() {
      const params = {
        "well" : this.fenceWells
      };

      const url = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/map/curve";
      axios.post(url, params).then(res => {
        this.curveNameOptions = [];
        for(const wellCurve of res.data.data) {
          console.log(wellCurve);
          // TODO 合并所有曲线作为曲线选项
        }
      }).catch(err => {
        console.log(err);
      });
    },
    clickTreeNode(data, node) {
      this.itemType = data.type;
      this.itemData = data;
      this.itemNode = node;
      this.showContextMenu = false;
    },
    treeNodeMenu(e, data, node) {
      e.preventDefault();
      this.itemType = data.type;
      this.itemData = data;
      this.itemNode = node;
      this.showContextMenu = this.itemType !== 'MapSetting';
      if (this.showContextMenu) {
        this.itemMoveable = this.itemType.indexOf('Track') !== -1 || this.itemType === 'LogCurve';
        this.OnShowContextMenu(e);
      }
    },
    itemMoveUp() {
      this.showContextMenu = false;
      const items = this.itemNode.parent.childNodes;
      const datas = this.itemNode.parent.data.children;
      const idx = items.indexOf(this.itemNode);
      if (idx === 0) {
        ElMessage({type:"info",message:"已经到最前"})
      } else {
        [items[idx],items[idx-1]] = [items[idx-1],items[idx]];
        [datas[idx],datas[idx-1]] = [datas[idx-1],datas[idx]];
      }
    },
    itemMoveDown() {
      this.showContextMenu = false;
      const items = this.itemNode.parent.childNodes;
      const datas = this.itemNode.parent.data.children;
      const idx = items.indexOf(this.itemNode);
      if (idx+1 === items.length) {
        ElMessage({type:"info",message:"已经到最后"})
      } else {
        [items[idx],items[idx+1]] = [items[idx+1],items[idx]];
        [datas[idx],datas[idx+1]] = [datas[idx+1],datas[idx]];
      }
    },
    itemDelete() {
      this.showContextMenu = false;
      this.itemNode.parent.removeChild(this.itemNode);
    },
    addCurve() {
      ElMessageBox.prompt('曲线名称', '添加曲线', {
        confirmButtonText : '确定',
        cancelButtonText: '取消',
        inputPattern:/.+/,
        inputErrorMessage: '无效的曲线名称'
      })
      .then(({value})=>{
        const curve = newCurve(value);
        this.itemData.children.push(curve);
      });
    },
    addTrack(e) {
      const trackType = e.target.innerText;
      const trackClass = e.target.id;

      ElMessageBox.prompt('道名称', `添加${trackType}`, {
        confirmButtonText : '确定',
        cancelButtonText: '取消',
        inputPattern:/.+/,
        inputErrorMessage: '无效的道名称'
      }).then(({value}) => {
        const track = newTrack(trackClass, value);
        if (track) {
          this.itemData.children.push(track);
        }
      });
    },
    OnShowContextMenu(e) {
      window.addEventListener('click', this.clickToExitMenu);

      const tree = document.querySelector("#leftTree");
      const treeRect = tree.getBoundingClientRect();

      const menu = document.querySelector("#right-key-menu");
      menu.left = e.clientX - treeRect.left + 50;
      menu.top = e.clientY - treeRect.top + 60 ;
      menu.style.left = menu.left + 'px';
      menu.style.top = menu.top + 'px';
    },
    clickToExitMenu() {
      this.showContextMenu = false;
      window.removeEventListener('click', this.clickToExitMenu);
    },
    adjustBorderStyle(config, style) {
      let tracks = []

      for(let track of config.children) {
        if (track.type === 'StackedTrack') {
          for(let childTrack of track.children) {
            tracks.push(childTrack)
            this.adjustTrackBorderStyle(childTrack, style);
          }
        } else {
          tracks.push(track);
          this.adjustTrackBorderStyle(track, style);
        }
      }

      if (style === 2 && tracks.length > 0) {
        tracks[0].leftBorder = false;
        tracks[tracks.length-1].rightBorder = false;
      }
    },
    adjustTrackBorderStyle(track, style) {
      track.showHeaderBorder = Boolean(style === 2 ? 0 : style);
      track.showBorder = Boolean(style);
      track.leftBorder = Boolean(style);
      track.rightBorder = Boolean(style);
      track.topBorder = Boolean(style);
      track.bottomBorder = Boolean(style);

      if (track.type === "LogCurveTrack") {
        for(let curve of track.children) {
          curve.showHeaderBorder = Boolean(style === 2 ? 0 : style);
        }
      }
    },
    getTemplate() {
      for(const config of this.template) {
        if (config.type === 'WellSetting') {
          if (config.borderStyle === 0 || config.borderStyle === 1 ) {
            // 0 隐藏边框 1 显示边框
            this.adjustBorderStyle(config, config.borderStyle);
          } else {
            // 2 栅状图默认样式 隐藏道头，隐藏最左道左边框和最右道右边框
            this.adjustBorderStyle(config, config.borderStyle);
          }
        }
      }
      return this.template;
    },
    endEdit() {
      this.itemType = "";
      this.itemData = "";
      this.itemNode = null;
    }
  }
// ,watch:{
//     fence(newValue, oldValue){
//       console.log("fence changed! ", newValue, oldValue);
//       this.template = JSON.parse(JSON.stringify(this.fence));
//       this.itemType = "";
//       this.itemData = "";
//       this.itemNode = null;
//     }
//   }
}
</script>

<style scoped>

.leftTree{
  height:400px;
  overflow-x: scroll;
}
.leftTree::-webkit-scrollbar{
  display: none;
}
.rightTable{
  padding-left:10px;
  border-left: #dcdfe6 1px solid;
  height:400px;
  overflow: auto;
}
.right-key-menu {
  display: block;
  line-height: 34px;
  text-align: center;
}
.right-key-menu:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.right-key-menu {
  position: absolute;
  background-color: #fff;
  width: 100px;
  font-size: 12px;
  color: #444040;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  white-space: nowrap;
  z-index: 1000;
}
.rightKeyMenuItem:hover {
  cursor: pointer;
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}
.fence-color-block{
  display: flex;
  align-items: center;
}
.fence-color-block .color-label{
  margin-right: 5px;
}
.el-row{
  margin-top: 2px;
}
</style>